// import Vue from 'vue'
import server from '../../api/server'
import ClaimSteps from '../../components/assist/ClaimSteps'
import DeedSteps from '../../components/assist/DeedSteps'
import PostSteps from '../../components/assist/PostSteps'
import ContractorCheckSteps from '../../components/assist/ContractorCheckSteps'
import BinderSteps from '../../components/assist/BinderSteps'
import PackageSteps from '../../components/assist/PackageSteps'
import uuid from 'uuid'
import StoreClasses from './StoreClasses'

const state = {
  assistMatterSet: new StoreClasses.ItemSet(item => item.id),
//  assistMatters: [],
  deeds: [],
  folders: [],
  types () {
    return new Map([
      ['CLAIM', 'Претензия'],
      ['DEED', 'Документ'],
      ['BINDER', 'Подшивка'],
      ['PACKAGE', 'Пакет'],
      ['POST', 'Рассылка'],
      ['CONTRACTOR_CHECK', 'Проверка контрагента']
    ])
  }
}

function getStrategy (typeCode, cxt) {
  switch (typeCode) {
    case 'CLAIM': return ClaimSteps.createStrategy(cxt)
    case 'DEED': return DeedSteps.createStrategy(cxt)
    case 'BINDER': return BinderSteps.createStrategy(cxt)
    case 'PACKAGE': return PackageSteps.createStrategy(cxt)
    case 'POST': return PostSteps.createStrategy(cxt)
    case 'CONTRACTOR_CHECK': return ContractorCheckSteps.createStrategy(cxt)
  }
  return ClaimSteps.createStrategy(cxt)
}

function createModel (typeCode) {
  switch (typeCode) {
    case 'CLAIM': return new ClaimSteps.Model()
    case 'DEED': return new DeedSteps.Model()
    case 'BINDER': return new BinderSteps.Model()
    case 'PACKAGE': return new PackageSteps.Model()
    case 'POST': return new PostSteps.Model()
    case 'CONTRACTOR_CHECK': return new ContractorCheckSteps.Model()
  }
  return new ClaimSteps.Model()
}

class AssistMatter {
  constructor (ops) {
    var options = Object.assign({}, ops)
    this.id = options.id || uuid()
    this.typeCode = options.typeCode || 'CLAIM'
    this.type = this.typeCode.localeCompare('CLAIM') === 0 ? 'Претензия' : 'Новый тип'
    this.created = options.created || new Date()
    this.state = options.state || 'NEW'
    this.name = options.name || null
    this.notes = options.notes || null
    this.model = options.model || createModel(this.typeCode)
    this.accountNameShort = options.accountNameShort || null
  }
  copy () {
    var model = this.model.copy()
    return Object.assign(new AssistMatter(), this, {model: model})
  }
}

// getters
const getters = {
  getAssistMatterTypes: state => state.types,
  getAssistMatterSet: state => state.assistMatterSet,
//  getAssistMatters: state => state.assistMatters,
  getNewAssistMatter: state => (ops) => new AssistMatter(ops),
  getAssistMatterStrategy: state => (typeCode, cxt) => getStrategy(typeCode, cxt),
  getAssistDeedFolders: state => state.folders,
  getAssistDeedsByPath: state => (path) => {
    let map = {}
    state.deeds
    .filter(d => (!path) || (!d.path) || d.path.startsWith(path))
    .forEach(d => { map[d.value] = {value: d.value, text: d.text, description: d.description} })
    return Object.values(map)
  }
}

// actions
const actions = {
  getAssistScheme ({commit, state, getters}, itemId) {
    return new Promise((resolve, reject) => {
      server.apiGet(
        '/api/me/assist/matters/' + itemId + '/scheme',
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о полях запроса ассистенту '})
          reject(e)
        }
      )
    })
  },
  getAssistMatter ({commit, state, getters}, itemId) {
    return new Promise((resolve, reject) => {
      server.apiGet(
        '/api/me/assist/matters/' + itemId,
        (data) => {
          data.model = Object.assign(createModel(data.typeCode), JSON.parse(data.model))
          resolve(new AssistMatter(data))
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о запросе ассистенту '})
          reject(e)
        }
      )
    })
  },
  getAssistMatterActions ({commit, state, getters}, itemId) {
    if (!itemId) {
      return Promise.resolve([])
    }
    return new Promise((resolve, reject) => {
      server.apiGet(
        '/api/me/assist/matters/' + itemId + '/actions',
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка действий для дела'})
          reject(e)
        }
      )
    })
  },
  fetchAssistMatters ({commit, state, getters}, force) {
    if (getters.getProfileLoaded && (getters.getProfileHaveClient !== true)) {
      return
    }
    if (!force && !state.assistMatterSet.isChanged()) {
      return
    }
    var page = force ? 0 : state.assistMatterSet.page
    let sort = state.assistMatterSet.sort
    console.log('fetchAssistMatters', sort)
    var fxt = Object.assign({}, getters.getAssistMatterSet.getFilter())
    commit('startAssistMatters')
    server.apiGetParams(
      '/api/me/assist/matters',
      {
        size: 100,
        page: page,
        sort: sort,
        request: {
          search: fxt.search,
          tagIds: fxt.tagIds
        }
      },
      (data) => {
        commit('setAssistMatters', {data: data, cxt: fxt})
        commit('setSuccessStatus')
      },
      (e) => {
        commit('stopAssistMatters')
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка запросов к ассистенту '})
      }
    )
  },
  deleteAssistMatters ({commit, state, rootState}, requests) {
    server.apiPost(
      '/api/me/assist/command-matters-deletes',
      {ids: requests.ids},
      (data) => {
        this.dispatch('fetchAssistMatters', true)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при удалении запросов ассистенту '})
      }
    )
  },
  copyAssistMatters ({commit, state, rootState}, requests) {
    server.apiPost(
      '/api/me/assist/command-matters-copies',
      {ids: requests.ids},
      (data) => {
        this.dispatch('fetchAssistMatters', true)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при копировании дел '})
      }
    )
  },
  createAssistPackage ({commit, state, rootState}, request) {
    console.log('createAssistPackage', request)
    server.apiPost(
      '/api/me/assist/packages',
      request,
      (data) => {
        console.log('createAssistPackage', data)
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при копировании дел '})
      }
    )
  },
  updateAssistMatter ({commit, state}, request) {
    return new Promise((resolve, reject) => {
      var item = Object.assign({}, request)
      // console.log('updateAssistMatter', item)
      item.model = JSON.stringify(item.model)
      server.apiPost(
        '/api/me/assist/matters',
        item,
        (data) => {
          this.dispatch('fetchAssistMatters')
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении запроса для ассистента '})
          reject(e)
        }
      )
    })
  },
  updateAssistMatterName ({commit, state}, request) {
    return new Promise((resolve, reject) => {
      var item = Object.assign({}, request)
      // console.log('updateAssistMatter', item)
      server.apiPost(
        '/api/me/assist/matters/' + item.id + '/command-name-updates',
        item,
        (data) => {
          this.dispatch('fetchAssistMatters', true)
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при изменении названия запроса для ассистента '})
          reject(e)
        }
      )
    })
  },
  depoAssistMatter ({commit, state}, request) {
    return new Promise((resolve, reject) => {
      var item = Object.assign({}, request)
      server.apiPost(
        '/api/me/assist/matters/' + item.id + '/command-depos',
        item,
        (data) => {
          resolve(data)
          this.dispatch('fetchDashboardCounters')
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при депонировании результатов дела '})
          reject(e)
        }
      )
    })
  },
  macroAssistMatter ({commit, state}, request) {
    return new Promise((resolve, reject) => {
      var item = Object.assign({}, request)
      server.apiPost(
        '/api/me/assist/matters/' + item.id + '/command-transforms',
        item,
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при выполнении макроса '})
          reject(e)
        }
      )
    })
  },
  sendAssistMatter ({commit, state}, request) {
    return new Promise((resolve, reject) => {
      var item = Object.assign({}, request)
      server.apiPost(
        '/api/me/assist/matters/' + item.id + '/command-sends',
        item,
        (data) => {
          commit('setStatus', {show: true, type: 'success', message: 'Письма подготовлены и поставлены в очередь.'})
          this.dispatch('fetchDashboardCounters')
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка во время подготовки писем'})
          reject(e)
        }
      )
    })
  },
  fetchDeeds ({commit, state, getters}) {
    if (getters.getProfileLoaded && (getters.getProfileHaveClient !== true)) {
      return
    }
    server.apiGet(
      '/api/me/assist/deeds',
      (data) => {
        commit('setAssistDeeds', data)
        commit('setSuccessStatus')
      },
      (e) => {
        commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка типов документов '})
      }
    )
  },
  getAssistDeed ({commit, state, getters}, itemId) {
    return new Promise((resolve, reject) => {
      server.apiGet(
        '/api/me/assist/deeds/' + itemId,
        (data) => {
          resolve({id: itemId, name: (data && data.name) || null})
        },
        (e) => {
          resolve({id: itemId, name: null})
        }
      )
    })
  }
}

// mutations
const mutations = {
  // setAssistMatters (state, data) {
  //   state.assistMatters = data.map(m => {
  //     m.model = Object.assign(createModel(m.typeCode), JSON.parse(m.model))
  //     return new AssistMatter(m)
  //   })
  // },
  setAssistMatterFilterContext (state, cxt) {
    state.assistMatterSet.setFilter(cxt)
  },
  setAssistMatterSort (state, sort) {
    state.assistMatterSet.setSort(sort)
  },
  startAssistMatters (state) {
    state.assistMatterSet.clearChanged()
    state.assistMatterSet.start()
  },
  stopAssistMatters (state) {
    state.assistMatterSet.stop()
  },
  nextAssistMatters (state) {
    state.assistMatterSet.nextPage()
  },
  setAssistMatters (state, {data, cxt}) {
    state.assistMatterSet.setItems(data, cxt)
    state.assistMatterSet.stop()
  },
  setAssistDeeds (state, data) {
    state.deeds = data.filter(d => d.id.startsWith('FOLDER') === false).map(d => {
      return {value: d.id, text: d.name, description: d.description, path: d.path}
    })
    state.folders = data.filter(d => d.id.startsWith('FOLDER')).map(d => {
      return {value: d.path, text: d.name, description: d.description}
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/assist.js